module.exports = "<button class=\"clear large flush flush-icon icon-clear-text clear-pad-btn\"\n        (click)=\"clear()\">\n  <span class=\"sr-only\">Clear Signature</span>\n</button>\n<signature-pad (onEndEvent)=\"drawComplete()\"></signature-pad>\n<p class=\"help-text\">Sign Above</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/survey/signature-question/signature-question.component.html
// module id = 292
// module chunks = 1